/**
 * 常用语言名称映射
 * MVP版本：支持最常用的30+语言
 */
export const LANGUAGE_NAMES = {
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
  'en': 'English',
  'en-US': 'English (US)',
  'en-GB': 'English (UK)',
  'ja': '日本語',
  'ko': '한국어',
  'fr': 'Français',
  'de': 'Deutsch',
  'es': 'Español',
  'pt': 'Português',
  'pt-BR': 'Português (Brasil)',
  'ru': 'Русский',
  'it': 'Italiano',
  'nl': 'Nederlands',
  'pl': 'Polski',
  'tr': 'Türkçe',
  'ar': 'العربية',
  'th': 'ไทย',
  'vi': 'Tiếng Việt',
  'id': 'Bahasa Indonesia',
  'ms': 'Bahasa Melayu',
  'hi': 'हिन्दी',
  'bn': 'বাংলা',
  'ta': 'தமிழ்',
  'te': 'తెలుగు',
  'ur': 'اردو',
  'fa': 'فارسی',
  'he': 'עברית',
  'sv': 'Svenska',
  'da': 'Dansk',
  'no': 'Norsk',
  'fi': 'Suomi',
  'cs': 'Čeština',
  'hu': 'Magyar',
  'ro': 'Română',
  'el': 'Ελληνικά',
  'uk': 'Українська'
};

/**
 * 获取语言显示名称
 * @param {string} langCode - 语言代码
 * @returns {string} 语言显示名称
 */
export function getLanguageName(langCode) {
  return LANGUAGE_NAMES[langCode] || langCode;
}